import Vue from 'vue'
import VueMarkdown from 'vue-markdown'
import { mapGetters, mapActions } from 'vuex'
// import anime from 'animejs'

import Navigation from '@/components/Navigation'

// SECTIONS
import articleView from '@/components/sections/articleView'
import contentSlider from '@/components/sections/contentSlider'
import collectionGrid from '@/components/sections/collectionGrid'
import collectionGridImg from '@/components/sections/collectionGridImg'
import collectionList from '@/components/sections/collectionList'
import textblockImgLeft from '@/components/sections/textblockImgLeft'
import textblockImgRight from '@/components/sections/textblockImgRight'
import textblockImgAlternate from '@/components/sections/textblockImgAlternate'
import imageGrid from '@/components/sections/imageGrid'
import pageFooter from '@/components/sections/pageFooter'

export default {
  props: [ 'page', 'id' ], // any @router props passed should be included here. id is used as a post/product id etc.
  components: { VueMarkdown, Navigation, articleView, contentSlider, collectionGrid, collectionGridImg, collectionList, textblockImgLeft, textblockImgRight, textblockImgAlternate, imageGrid, pageFooter },
  data () {
    return {
      title: '',
      desc: '',
      image: '',
      template: '',
      name: '',
      sections: {}
    }
  },
  beforeRouteEnter (to, from, next) {
    // console.log('TO: ', to, 'FROM: ', from, 'NEXT: ', next)
    next((vm) => {
      vm.update(to, 'beforeRouteEnter')
    })
  },
  watch: {
    'pages': function (data) { // watches for pages in store to be populated/changed
      this.update(data, 'watch')
    }
  },
  methods: {
    update (payload, src) {
      // console.log(src + ' calling update with payload', payload)
      let data = payload != null
        ? () => {
          if (this.$root.$route.path === '/') {
            console.log('index', this.pageFields('index'));
            return this.pageFields('index')
          } else if (this.page != null) {
            return this.pageFields(this.page)
          } else {
            return null
          }
        }
        : null

      // if (data() !== null) {
        const fields = this.$root.$route.path === '/' ? this.pageFields('index') : this.pageFields(this.page)
        fields && this.setPageInfo(fields)

        // this.setSections(data())
      // } else {
        // console.warn('no page data')
      // }
    },
    ...mapActions([
      'getContentTypes',
      'getEntries',
      'getLinkedEntries',
      'getEntry',
      'getAsset'
    ]),
    pageFields (p) {
      // console.log(p, this.$store.state.pages, this.pages)
      return this.pages[p]
    },
    setPageInfo (fields) {
      // console.log('setPageInfo', fields, fields.title)
      Vue.set(this, 'title', fields.title)
      Vue.set(this, 'desc', fields.description)
      Vue.set(this, 'image', fields.image)
      Vue.set(this, 'template', fields.templateId)
      Vue.set(this, 'name', fields.name)

      fields && this.setSections(fields)
    },
    setSections (fields) {
      // console.log('setSections', fields)
      // check for additional sections
      let component = this

      if (fields && fields.sections) {
        fields.sections.forEach((d) => {
          // TODO get the content if the nested content is not available (i.e limit is reached) y sys.id
          Vue.set(component.sections, d.fields.name, d)
          // this.getEntry(d.sys.id)
          //   .then(function (d) { Vue.set(component.sections, d.fields.name, d) })
        })
      }
    },
    kebabToCamel (s) {
      return s.replace(/(-\w)/g, m => m[1].toUpperCase())
    }
  },
  computed: {
    ...mapGetters([
      'domain',
      'pages',
      'products'
    ])
  },
  created () {
  },
  mounted () {
  }
}



// WEBPACK FOOTER //
// ./src/scenes/_pageBase.js